export const NAME = 'questions';
export default NAME;
